import { useEffect, useState, type FC } from 'react';

import { Button, Typography, Icon, useDeviceType } from 'pixel-react';
import { useNavigate } from 'react-router-dom';

import { useEmailActivateMutation } from '@/store/activateEmail/activateEmailSlice';
import type { verifyTokenResponce } from '@/types/verifyToken';

import styles from './ActivationSuccess.module.scss';
import { SignUpWrapper } from '../SignUpWrapper';

export const ActivationSuccess: FC = () => {
  const clientName = import.meta.env.VITE_CLIENT_DETAIL?.name;
  const WebsiteUrl = 'https://www.fireflink.com';
  const navigate = useNavigate();
  const { isMobile } = useDeviceType();
  const [activateEmailApi] = useEmailActivateMutation();
  const [urlData, setUrlData] = useState({
    userId: '',
    token: '',
    emailId: '',
  });
  const activateEmail = async (
    userid: string | null,
    token: string | null,
    emailId: string,
  ) => {
    const payload = {
      id: userid,
      passwordToken: token,
    };

    try {
      const result = (await activateEmailApi(
        payload,
      ).unwrap()) as verifyTokenResponce;

      if (
        result.responseCode === 400 &&
        result?.message === 'User is already activated'
      ) {
        navigate(`/token-expired?emailId=${emailId}?activationStatus=ACTIVE`);
      }
      if (
        //TODO:this 'Token is invalid/Expired' should have some API identifier
        result.responseCode === 400 &&
        result?.message === 'Token is invalid/Expired'
      ) {
        navigate(
          `/token-expired?emailId=${emailId}?activationStatus=${result?.status}`,
        );
      }
    } catch (error) {
      console.error('Verify Token Failed!', error);
    }
  };
  useEffect(() => {
    const search = window.location.search;
    const token = new URLSearchParams(search).get('token');
    const userid = new URLSearchParams(search).get('userid');
    const emailId = new URLSearchParams(search).get('emailId') || '';

    if (userid && token) {
      setUrlData({ userId: userid, token: token, emailId: emailId });
    }
    activateEmail(userid, token, emailId);
  }, []);
  const handleSubmit = async () => {
    navigate('/signin');
  };

  return (
    <SignUpWrapper
      content_header={
        <>
          {' '}
          <Typography fontSize="25px" fontWeight="bold" lineHeight="0.8">
            SIMPLIFY TESTING. AMPLIFY QUALITY.
          </Typography>{' '}
        </>
      }
      sub_content={`${clientName} is your all-in-one testing solution — combining AI-driven intelligence with Super Automation to streamline end-to-end testing and supercharge your QA process.`}
      footer_content={`Get. Set. ${clientName}!`}
      copyright_content={`Copyright © ${clientName} Pvt Ltd. All Rights Reserved`}
      className={styles.activation_container}
    >
      <section className={styles.form_container}>
        <aside className={styles.activation_form}>
          <section className={styles['icon_container']}>
            <Icon
              color=""
              height={isMobile ? 160 : 240}
              width={isMobile ? 160 : 240}
              name="user_with_system"
            />
          </section>
          <section className={styles.activation_form_header}>
            <Typography
              fontSize="32px"
              textAlign="center"
              className={styles['header_text']}
            >
              Activation Successful
            </Typography>

            <Typography
              fontSize="16px"
              textAlign="center"
              lineHeight="22px"
              className={styles['sub_header_text']}
            >
              <Typography
                fontSize="16px"
                textAlign="center"
                lineHeight="22px"
                className={styles['highlighted_text']}
              >
                Welcome Aboard!
              </Typography>{' '}
              Your account is now activated and ready for use.
            </Typography>
          </section>

          <div className={styles.activation_footerbtn}>
            <div className={styles.footerBtn_container}>
              <div className={styles.activation_footerbtn}>
                <Button
                  buttonWidth="260px"
                  type="submit"
                  variant="primary"
                  onClick={handleSubmit}
                >
                  <Typography
                    fontSize="16px"
                    className={styles['register_btn']}
                  >
                    Proceed to Sign In
                  </Typography>
                </Button>
              </div>
              <div className={styles.backward_footerbtn}>
                <Button
                  onClick={() => {
                    window.location.href = WebsiteUrl;
                  }}
                  type="submit"
                  variant="secondary"
                  buttonWidth="233px"
                >
                  <Typography fontSize="16px" fontWeight="bold">
                    Go to Website
                  </Typography>
                </Button>
              </div>
            </div>
          </div>
        </aside>
      </section>
    </SignUpWrapper>
  );
};
